import React from 'react'
import styled from 'styled-components'
import {
  Input as AntInput,
  Modal as AntModal,
  ModalFooter,
} from 'reactstrap'
import { IoIosCloseCircle } from 'react-icons/io'
import { FaRegCopy } from 'react-icons/fa'

import { Button } from '../../../buttons'

import { FONTS } from '../../../../constants'

export const CopyCostModal = ({ open, toggle, copyCost }) => {
  return (
    <Modal
      isOpen={ open }
      toggle={ () => toggle({ show: false }) }
    >
      <ModalHeader toggle={ () => toggle({ show: false }) }>
        <HeaderText>Copy more</HeaderText>
        <IoIosCloseCircle onClick={ () => toggle({ show: false }) } />
      </ModalHeader>
      <BodyWrapper>
        <Text>Number of rows need for copies</Text>
        <Input
          id='numberOfCopies'
          onChange={ e => {
            const value = e.target.value
            if (!new RegExp('^[0-9]*$').test(value)) {
              e.target.value = value.substring(0, value.length - 1)
            } else if (parseInt(e.target.value, 10) > 60) {
              e.target.value = 60
            }
          } }
        />
      </BodyWrapper>
      <ModalFooter>
        <Button
          width='70px'
          height='26px'
          theme='#28a745'
          icon={ <FaRegCopy style={ { fontSize: 16 } } /> }
          onClick={ copyCost }
        >
          Copy
        </Button>
        <Button
          width='70px'
          height='26px'
          theme='#6c757d'
          onClick={ () => toggle({ show: false }) }
        >
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  )
}

const Input = styled(AntInput)`
  height: 40px;
`

const Modal = styled(AntModal)`
  .modal-header {
    border: none;
  }

  .modal-footer {
    border: none;
    background: #F9F9F9;
  }
`

const ModalHeader = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 24px 16px 0 16px;

    svg {
        font-size: 24px;
        color: #C4C4C4;
        cursor: pointer;
    }
`

const HeaderText = styled.span`
  font-family: ${FONTS.GOTHAM_BOLD};
  font-size: ${FONTS.TITLE_SIZE};
  color: #333333;
`

const BodyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.SMALL_SIZE};
  padding: 28px 16px 24px 16px;
`

const Text = styled.span`
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.SMALL_SIZE};
  color: #C4C4C4;
  margin-bottom: 8px;
`



// WEBPACK FOOTER //
// ./src/components/project-information/tab-content/tab-cost-planning/copy-cost-modal.js